import { useContext } from 'react';
import { LoginStateContext } from './LoginStateContext';

export function useLoginForm() {
  const context = useContext(LoginStateContext);

  if (!context) {
    // not necessarily mandatory, but we want to make sure this consumer is only used for consuming LoginStateContext's form
    throw new Error('useLoginForm must be used within a LoginStateProvider');
  }

  return context.loginFormMethods;
}
